import Nav from "../components/Nav";
import Footer from "../components/Footer";

export default {
  /**
   *
   */
  props: {
    navProps: {
      type: Object,
      default: function () {
        return { sticky: true, fixed: false }
      }
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    return (
      <div>
        <Nav sticky={this.navProps.sticky} fixed={this.navProps.fixed} />
        { this.$slots.default }
        <Footer />
      </div>
    );
  }
}
